import Vue from 'vue'
import './plugins/axios'
import 'amfe-flexible'
import { Toast } from 'vant'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css';


import { DatetimePicker } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Icon } from 'vant';
import { Button } from 'vant';
import { NavBar } from 'vant';
import { Search } from 'vant';
import { Grid, GridItem } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { NumberKeyboard } from 'vant';
import { Field } from 'vant';
import { Popup } from 'vant';
import { Notify } from 'vant';
import { List } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Dialog } from 'vant';
import { Panel } from 'vant';
import { Divider } from 'vant';
import { RadioGroup, Radio } from 'vant';

import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Divider);
Vue.use(Panel);
Vue.use(DatetimePicker);
Vue.use(Dialog);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(List);
Vue.use(Notify);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Search);
Vue.use(Icon);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(NavBar);
Vue.use(Toast)
Vue.use(Button);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(NumberKeyboard);


Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  Vue.prototype.$toast.clear()
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')